import { analyticsFormat, analyticsScope, trackAdobeEvent } from './adobe';

function safelyParseTimestamp(publicationDateNumber) {
  try {
    const date = new Date(publicationDateNumber);
    const time = date.getTime();
    return Number.isNaN(time) ? '' : `${time}`;
  } catch {
    return '';
  }
}

const createArticleDetail = (component, panel, hasPdf) => ([
  'sd', 'er',
  panel,
  ...(component ? [component] : []),
  'cit-count', 'notavailable',
  'has_pdf', hasPdf,
  'signals', 'scopus', 'no', 'articles', 'no', 'mendeley', 'no', 'sciencedirect', 'yes',
].join(':'));

const createAnalyticsContent = analyticsMetadata => (article) => {
  const {
    pii: id,
    traceToken: id2,
    contentType,
    documentType,
    openAccessContent,
    pdfPath,
    position,
    publicationDateNumber,
  } = article;

  const {
    component,
    format,
    panel,
    scope,
  } = analyticsMetadata;

  return {
    id,
    id2,
    type: `sd:${documentType}:${contentType}:${scope}`,
    position: `${position}`,
    detail: createArticleDetail(component, panel, !!pdfPath),
    format,
    entitlementType: openAccessContent ? 'openaccess' : 'other',
    publishDate: safelyParseTimestamp(publicationDateNumber),
  };
};

function trackRecommendationEvent(event, articles, analyticsMetadata) {
  trackAdobeEvent(event, {
    page: {
      recommenderVersion: 'sd-article-non-personal-recommender:v1.0',
    },
    content: articles.map(createAnalyticsContent(analyticsMetadata)),
  });
}

export const createRecommendationClickTracker = (panel, article) => (analyticsMetadata) => {
  trackRecommendationEvent('recommendationClick', [article], {
    ...analyticsMetadata,
    panel,
  });
};

export function trackRecommendationViews(panel, articles) {
  trackRecommendationEvent('recommendationViews', articles, {
    scope: analyticsScope.CARD,
    format: analyticsFormat.MIME_HTML,
    panel,
  });
}
